module.exports = __webpack_public_path__ + "static/media/refund_failed.c493f032.svg";